module.exports = __webpack_public_path__ + "static/media/activate_sound_icon.665cc7ba.svg";